<template>
  <b-modal size="xl" v-model="showModalMap" id="modal-map" centered
           body-class="my-body" hide-footer hide-header @hidden="hide">
    <b-row style=" flex-grow : 1; margin-bottom: 0px" :class="{ hidden: true, 'show-hidden': !isHidden }">
      <b-col id="sidebar_main" style="padding: 10px" class="sidebar2">
        <md-card style="background-color: white; max-height: 75vh; overflow-y: scroll;">
          <md-card-content>
            <b-row style="border-bottom:1px solid #b3b3b3; margin-bottom: 12px; margin-top: 16px">
              <b-col>
                <p style="color: #525252" class="font-lg"><b>Filter</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Beplant:" label-for="is_planned">
                  <b-form-select class="black" id="is_planned" plain v-on:input="changeFilter"
                                 v-model="selections.is_planned" :options="selects.is_planned">
                    <template v-slot:first>
                      <b-form-select-option :value="null">-- Alle --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </md-card-content>
        </md-card>
      </b-col>
      <b-col style="height: 600px; padding: 0; margin-bottom: 0; overflow: hidden" id="map_container"
             ref="map_container" v-on:toggle-sidebar="toggleSideBar">
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import TaskMapPopup from "@/views/aufgaben_verwaltung/TaskMapPopup.vue";
import ClearIcon from 'vue-material-design-icons/CloseCircle.vue';
import StylesControl from 'mapbox-gl-controls/lib/styles';


import Vue from 'vue';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import {arrayContains} from "@/shared/utils";

require('../../shared/free_draw');

class MyCustomControl {
  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
    this.button = document.createElement('button');
    this.button.innerHTML = "☰ Filter";
    this.button.onclick = () => {
      let event = new Event('toggle-sidebar');
      this.button.dispatchEvent(event);
    };
    this.container.appendChild(this.button);
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

const myCustomControl = new MyCustomControl();


export default {
  name: "PlanningMap",
  components: {
    ClearIcon,
  },
  data() {
    return {
      showModalMap: false,
      items: [],
      filteredItems: [],
      isHidden: true,
      closeToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "&#x2715; Schließen";
          this.button.onclick = this.parent.closeMap;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      createTourToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.container.id = 'create_tour'
          this.container.ref = 'create_tour'
          this.container.style.background = 'green';
          this.button = document.createElement('button');
          this.button.innerHTML = "Auswählen";
          this.button.onclick = this.parent.createTour;
          this.button.style.color = 'white';
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      sidebarToggle: new class {
        constructor(parent) {
          this.parent = parent;
        }

        onAdd(map) {
          this.map = map;
          this.container = document.createElement('div');
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-styles';
          this.button = document.createElement('button');
          this.button.innerHTML = "☰ Filter";
          this.button.onclick = this.parent.toggleSideBar;
          this.container.appendChild(this.button);
          return this.container;
        }

        onRemove() {
          this.container.parentNode.removeChild(this.container);
          this.map = undefined;
        }
      }(this),
      navopen: false,
      selects: {
        is_planned: [{value: 1, text: 'Ja'}, {value: 0, text: 'Nein'}],
      },
      selections: {
        is_planned: 0,
      },
    }
  },
  methods: {
    toggleSideBar() {
      if (!this.navopen) {
        document.getElementById("sidebar_main").style.width = "250px";
        document.getElementById("sidebar_main").style.visibility = "visible";
      } else {
        document.getElementById("sidebar_main").style.width = "0px";
        document.getElementById("sidebar_main").style.visibility = "hidden";
      }
      this.navopen = !this.navopen;
    },
    hide() {
      if (this.markers !== null) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].remove();
        }
        this.markers = null;
      }
      this.items = [];
      if (this.map !== null) {
        this.map.remove();
        this.map = null;
      }
    },
    closeMap() {
      this.showModalMap = false;
      this.map = null;
    },
    createTour() {
      let selected = [];
      let hasAlreadyPlanned = false;
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].isSelected) {
          let id = this.markers[i].id;
          selected.push(id);
        }
      }
      this.$emit('map_plan', selected);
      this.closeMap();
    },
    showMapIfNeeded() {
      let bounds = new (mapboxgl.LngLatBounds);
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].lat == 0 || this.items[i].lon == 0) {
          continue;
        }
        bounds.extend(new mapboxgl.LngLat(this.items[i].lon, this.items[i].lat));
      }
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        bounds: bounds,
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      this.map.addControl(this.sidebarToggle, 'top-left');
      this.map.addControl(this.draw, 'top-left');

      this.map.addControl(new ZoomControl(), 'bottom-right');
      this.map.addControl(this.closeToggle, 'top-right');
      this.map.addControl(this.createTourToggle, 'top-left');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.marker = null;
      this.markers = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    changeFilter() {
      this.filteredItems = [];
      for (let i = 0; i < this.items.length; i++) {
        let contains = true;
        if (this.selections.is_planned !== null
            && (
                (this.items[i].planned === 0 && this.selections.is_planned > 0) ||
                (this.items[i].planned === 1 && this.selections.is_planned === 0)
            )) {
          contains = false;
        }
        if (contains) {
          this.filteredItems.push(this.items[i])
        }
      }
      this.onAreaUpdated()
    },
    onAreaUpdated(e) {
      let polygons = this.draw.getAll();
      let hasInside = false;
      if (polygons.length === 0) {
        this.drawMarkers();
      } else {
        this.removeMarkers();
        for (let i = 0; i < this.filteredItems.length; i++) {
          let isInside = false;
          for (let j = 0; j < polygons.features.length; j++) {
            if (booleanPointInPolygon([this.filteredItems[i].lon, this.filteredItems[i].lat], polygons.features[j])) {
              isInside = true;
              hasInside = true;
              break;
            }
          }
          let el = document.createElement('div');
          el.className = isInside ? 'marker_selected' : 'marker';
          el.id = this.filteredItems[i].id;


          let marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.filteredItems[i].lon, this.filteredItems[i].lat])
              .addTo(this.map);
          marker.id = this.filteredItems[i].id;
          marker.isSelected = isInside;
          this.markers.push(marker);
        }
      }
      document.getElementById("create_tour").style.visibility = hasInside ? "visible" : "hidden";
    },
    removeMarkers() {
      if (this.markers === null || this.markers.length === 0) {
        this.markers = [];
        return;
      }
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].remove();
      }
      this.markers = [];
    },
    drawMarkers() {
      this.removeMarkers()
      for (let i = 0; i < this.filteredItems.length; i++) {
        let el = document.createElement('div');
        el.className = 'marker';
        el.id = this.filteredItems[i].id;
        //el.addEventListener('click', this.onMarkerClicked);

        let marker = new mapboxgl.Marker({
          element: el,
          anchor: 'center',
        })
            .setLngLat([this.filteredItems[i].lon, this.filteredItems[i].lat])
            .addTo(this.map);
        marker.id = this.filteredItems[i].id;
        this.markers.push(marker);
      }
    },
    mapLoad() {
      setTimeout(() => {
        if (this.markers === null) {
          this.onAreaUpdated();
          this.map.on('draw.create', this.onAreaUpdated);
          this.map.on('draw.delete', this.onAreaUpdated);
          this.map.on('draw.update', this.onAreaUpdated);
        }
        this.map.resize();
        this.isHidden = false;
      });
    },
    showMap(items) {
      console.log(items)
      this.isHidden = true;
      this.marker = null;
      this.markers = null;
      this.items = [];

      this.selections.is_planned = 0;

      for (let i = 0; i < items.length; i++) {
        this.items.push(items[i]);
      }
      this.filteredItems = [];
      for (let i = 0; i < this.items.length; i++) {
        let contains = true;
        if (this.selections.is_planned !== null
            && (
                (this.items[i].planned === 0 && this.selections.is_planned > 0) ||
                (this.items[i].planned === 1 && this.selections.is_planned === 0)
            )) {
          contains = false;
        }
        if (contains) {
          this.filteredItems.push(this.items[i])
        }
      }

      if (this.items.length === 0) {
        this.$emit('close-map', {reason: 'no-coords'})
        return;
      }
      this.showModalMap = true;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
  }
}
</script>

<style scoped>
.hoverable-icon:hover {
  cursor: pointer;
}
</style>

<style>
.black {
  color: black;
}
.mapboxgl-popup {
  max-width: 600px !important;
  z-index: 2;
}
.mapboxgl-popup-close-button {
  font-size: 20px;
}

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.marker_selected {
  background-image: url('../../../public/marker_selected.png');
  background-size: cover;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.my-body {
  padding: 0 !important;
}

.hidden {
  opacity: 0;
  transition: opacity 0.1s ease-in;
}

.mapboxgl-popup-close-button {
  outline: none !important;
}

.show-hidden {
  opacity: 1;
}


.sidebar2 {
  visibility: hidden;
  width: 0;
  position: absolute;
  z-index: 1 !important;
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  -moz-transition: 0.5s;
  padding: 0;
  top: 50px;
  -webkit-transition-property: width, visibility;
  transition-property: width, visibility;
  -moz-transition-property: width, visibility;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
  -moz-transition-timing-function: ease;
}

.mapboxgl-ctrl-top-left {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}

.mapboxgl-ctrl-top-left .mapboxgl-ctrl {
  display: flex;
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
  display: -o-flex;
}
.mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
  border-left: 1px solid #ddd;
  border-top: none;
}

.my-custom-control {
  color: #f00;
  background: #000;
  padding: 8px;
  border-radius: 4px;
  margin: 8px;
}

</style>
